



















































































































































































import { Vue, Prop, Component, Ref } from "vue-property-decorator";
import { BillShort as IBillShort } from "@/api/models/bill-short";
import { Bill as IBill } from "@/api/models/bill";
import { PaymentCreate as IPaymentCreate } from "@/api/models/payment-create";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import moment from "moment";
import api from "@/getinfo-api";
import { Employee as IEmployee } from "@/api/models/employee";
import { Contract as IContract } from "@/api/models/contract";
import Modal from "@/components/form/Modal.vue";
import TableActions from "@/components/form/TableActions.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  BillEdit as IBillEdit,
  Contractor as IContractor,
  User as IUser
} from "@/api/models";
import DocTemplateGenerate from "@/components/doc-tempates/DocTemplateGenerate.vue";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import { generatePdf } from "@/utils/files-helper";

@Component({
  components: {
    EntityFiles,
    CustomDatepicker,
    DocTemplateGenerateV2,
    DocTemplateGenerate,
    CustomButton,
    CustomTable,
    CustomTableCol,
    CustomTableItem,
    TableActions,
    Modal,
    DeleteMaterialModal
  }
})
export default class BillItemPreview extends Vue {
  @Prop() bill!: IBillShort;
  @Ref("modal") modal: any;
  amount: number = 0;
  showAddPaymentForm: boolean = false;
  responsibleId?: string;
  paymentAt?: Date = new Date();
  showDeleteModal: boolean = false;
  responsible!: IEmployee;
  contract!: IContract;
  contractor!: IContractor;
  user!: IUser;
  isPdfGeneration: boolean = false;

  data() {
    return {
      contract: undefined,
      responsible: undefined,
      responsibleId: undefined,
      contractor: undefined,
      user: undefined
    };
  }

  async _generatePdf(file: any) {
    this.isPdfGeneration = true;
    const response = await generatePdf(file).catch(
      (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      }
    );
    await this.addFiles([response.id], true);
    this.isPdfGeneration = false;
  }

  async addFiles(files: any, fromDocTemplate: boolean = false) {
    const { data } = await api.BillApi.get(this.bill.id);

    let params: IBillEdit = {
      contractId: data.contractId,
      number: data.number,
      responsibleId: data.responsibleId!,
      learningResources: data.learningResources,
      formedAt: data.formedAt,
      fileIds:
        data.files && fromDocTemplate
          ? [...data.files.map((el: any) => el.id), ...files]
          : [...files],
      price: data.price
    };

    api.BillApi.edit(this.bill.id, params).then((res: { data: IBill }) => {
      this.$emit("updateBillFiles", res.data);
      this.$store.dispatch("successToast");
    });
  }

  showModal() {
    //@ts-ignore
    this.$bvModal.show(this.id);
  }

  getContractor() {
    if (this.contract.clientId) {
      api.ContractorApi.getContractorNew(this.contract.clientId).then(
        (res: { data: any }) => {
          this.contractor = res.data;
        }
      );
    }
  }

  getUser() {
    if (this.contract.clientId) {
      api.UsersApi.get(this.contract.clientId).then((res: { data: IUser }) => {
        this.user = res.data;
      });
    }
  }

  goToEditPage() {
    this.$router.push({
      name: "billEdit",
      params: { billId: this.bill.id }
    });
  }

  get screenWidth() {
    return window.innerWidth;
  }

  async getResponse() {
    try {
      if (this.bill.contract?.id) {
        let contractResponse = await api.ContractApi.get(
          this.bill.contract!.id
        );
        this.contract = contractResponse.data;
        if (this.bill.responsible && this.bill.responsible.id) {
          let responsibleResponse = await api.EmployeeApi.get(
            this.contract.companyId,
            this.bill.responsible?.id
          );
          this.responsible = responsibleResponse.data;
        }
        this.contract.clientType === "user"
          ? this.getUser()
          : this.getContractor();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  deleteBill() {
    this.showDeleteModal = false;
    api.BillApi._delete(this.bill.id)
      .then(() => {
        this.$emit("updateBillsList");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.hideDeleteModal();
      });
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  get paid() {
    let result: number = 0;
    this.bill.payments.forEach(el => {
      result += el?.amount ?? 0;
    });
    return result;
  }

  get debt() {
    return this.bill.price - this.paid <= 0 ? 0 : this.bill.price - this.paid;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get billFormed() {
    return this.bill.formedAt
      ? moment(this.bill.formedAt).format("ll")
      : `${this.$tc(this.$translate.NotFilled)}`;
  }

  get styleForDebt() {
    return this.paid >= this.bill.price ? "full-paid" : "debt";
  }

  addPaymentToBill() {
    if (this.amount > 0) {
      let paymentParam: IPaymentCreate = {
        amount: this.$converter.setPrice(this.amount),
        responsibleId: this.responsibleId ? this.responsibleId : undefined,
        paymentAt: this.paymentAt ? this.paymentAt : undefined
      };

      api.BillApi.addPayment(this.bill.id, paymentParam)
        .then(() => {
          this.showAddPaymentForm = false;
          this.amount = 0;
          if (this.$route.name === "bills") {
            this.$emit("updateBill", this.bill.id);
          } else {
            this.$emit("updateBillsList");
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
          if (err.response?.status === 403) {
            this.$router.push({ name: "error" });
          }
        });
    }
  }

  created() {
    this.getResponse();
  }

  checkMaxAmount(value: number) {
    return value > this.$converter.getPrice(this.debt)
      ? this.$converter.getPrice(this.debt)
      : value;
  }
}
